// extracted by mini-css-extract-plugin
export default {"wrapper":"Datacheck_style_wrapper__JcPA9","description":"Datacheck_style_description__5ov13","rotate":"Datacheck_style_rotate__pnOH0"};